<template>
  <div>Sobre</div>
</template>

<script setup></script>
